// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./wp-content/themes/mk2018/static/src/sass/loic.scss
// module id = 10
// module chunks = 0